import { EMAIL_CONFIRMATION_NOTIFICATION_TYPE, INotification } from '@/modules/base/components/notification/notificationService'

/**
 * DO-13064: the "verify your e-mail" reminder is marked as read by the API the moment the address is
 * confirmed (see api services/notificationService/emailConfirmationRequired) — nothing else marks it
 * read. A read reminder is therefore done and must not linger in the list with its "Jetzt
 * verifizieren" button.
 */
export const isObsoleteEmailConfirmationNotification = (notification: Pick<INotification, 'readDate' | 'metaData'>): boolean =>
  notification.metaData?.type === EMAIL_CONFIRMATION_NOTIFICATION_TYPE && !!notification.readDate

export default isObsoleteEmailConfirmationNotification
